import { styled } from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 1rem;

  & button {
    width: 100%;
  }
`

export const BottomSheetContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`
